import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    errorText: {
        marginTop: 10
        , fontSize: 14
        , color: 'red'
    },
    page: {
        flex: 1
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    title: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    errorTitle: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.ERROR_CARD_BORDER_COLOR
    },
    body: {
        fontSize: 14
        , textAlign: 'center'
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    mainSpacers1: {
        flex: 1
        , paddingVertical: 10
        , justifyContent: 'flex-end'
        , alignItems: 'center'
    },
    mainSpacers2: {
        flex: 2
        , paddingVertical: 10
        , justifyContent: 'flex-start'
        , alignItems: 'center'
    },
    mainSpacers2Logo: {
        flex: 2
        , paddingVertical: 10
        , justifyContent: 'flex-end'
        , alignItems: 'center'
    },
    mainEmail: {
        borderWidth: 1
        , borderRadius: 6
        , borderColor: 'rgba(158, 168, 186, 0.65)'
        , fontSize: 20
        , paddingVertical: 15
        , paddingHorizontal: 20
    },
    mainButton: {
        backgroundColor: STYLES.DARK_GREEN
        , borderRadius: 30
        , paddingVertical: 15
        , paddingHorizontal: 60
        , shadowColor: STYLES.SHADOW_COLOR
        , shadowRadius: 40
        , shadowOffset: { width: 4, height: 6 }
    },
    mainButtonText: {
        fontSize: 22
        , color: STYLES.BACKGROUND_COLOR
    },
    logo: {
        width: 58
        , height: 129
    },
    checkmark: {
        width: 40
        , height: 40
        , marginBottom: 20
    },
    emailedSpacers1: {
        flex: 3
        , paddingVertical: 10
        , justifyContent: 'flex-end'
        , alignItems: 'center'
    },
    emailedSpacers2: {
        flex: 2
        , paddingVertical: 10
        , justifyContent: 'flex-start'
        , alignItems: 'center'
    },
    emailedButton: {

    },
    emailedButtonText: {
        fontSize: 14
        , color: STYLES.PRIMARY_TEXT_COLOR
        , textAlign: 'center'
    },
    pinInput: {
        fontSize: 22
        , borderWidth: 1
        , borderColor: STYLES.DARK_GREEN
        , borderRadius: 4
        , margin: 10
        , width: 40
        , height: 60
    }

})



// WEBPACK FOOTER //
// ./src/containers/login/styles.js